// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"354":"2f252e59ab67b31d4bc0","418":"d24664470cb71debc168","661":"b68be8e43fc51d2a5565"}[chunkId] + ".js";
};